import React from 'react';
import DALI from '../assets/footer/dali.svg';
import Potentia from '../assets/footer/potentia-white.svg';
import FullLine from '../assets/footer/fullLine.svg';

const Footer = (props) => {
  return (
    <div className="footer-bar">
      <div className="footer-logo-col">
        <img className="potentia-white-logo" src={Potentia} alt="potentia-logo" />
        <div>
          <h3>Potentia Institute 21</h3>
          <div className="footer-link">
            <a href="https://www.potentiainstitute21.org/">Potentia 21 Website</a>
          </div>
          <div className="logo-container">
            <p>BUILT IN COLLABORATION WITH THE</p>
            <img className="dali-logo" src={DALI} alt="dali-logo" />
          </div>
        </div>

      </div>
      <div className="footer-col">
        <div className="footer-text">
          Our Scientific References
        </div>
        <img src={FullLine} className="line-limit-1" alt="hi" />
        <div className="footer-link">
          <a href="http://researchmap.digitalpromise.org/wp-content/uploads/sites/11/2018/12/SoLPoster_v2r2.pdf">The Learning Sciences</a>
        </div>
        <div className="footer-link">
          <a href="https://www.cast.org/binaries/content/assets/common/publications/articles/cast-udlandthebrain-20190501.pdf">Universal Design for Learning</a>
        </div>
        <div className="footer-link">
          <a href="https://digitalpromise.org">Digital Promise</a>
        </div>
      </div>
      <div className="footer-col">
        <div className="footer-text">
          Contact Us
        </div>
        <img src={FullLine} alt="solid-line" className="line-limit-2" />
        <div className="footer-link">
          1 (650) 393-9308
        </div>
        <div className="footer-link">
          <a href="mailto:information@potentiainstitute21.org">Email Us</a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
